import React, { useState, useEffect, useContext } from "react";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import BackButton from "../Buttons/BackButton";
import { useForm } from "react-hook-form";
import FieldError from "../FieldError";
import { AppContext } from "../../contexts/AppContext";
import {
  getCountryNameById,
  getLabelFromId,
} from "../../Services/localStorage.tsx";
import { useNavigate } from "react-router-dom";
import GenderChange from "../GenderChange/index.js";
import NameChange from "../NameChange/index.js";
import Check from "../../assets/images/Check.svg";

const ReviewBirthDetails = ({ handleNext, handleBack }) => {
  const { handleSubmit } = useForm();
  const navigate = useNavigate();

  const { appState, userFlows } = useContext(AppContext);

  const birthData = appState.requestPayload.applicant;
  const supportingInformation = appState.requestPayload.supportingInformation;
  const eventData = appState.requestPayload.eventTypeSearch[0] || {};

  // console.log("ReviewPassport Data:", birthData, eventData, changedName);

  const [genderLabel, setGenderLabel] = useState("");
  const [addressCountryLabel, setAddressCountryLabel] = useState("");

  useEffect(() => {
    getLabelFromId("GenderReference", eventData?.genderId).then(
      (genderLabel) => {
        setGenderLabel(genderLabel);
      }
    );

    getCountryNameById(birthData.countryOfBirthId).then((countryName) => {
      setAddressCountryLabel(countryName);
    });
  }, [eventData?.genderId, birthData?.countryOfBirthId]);

  const onSubmit = () => {
    if (userFlows.showPartnerStore) {
      navigate("/app/photo-id");
      return;
    }
    if (!userFlows.showLiveness) {
      navigate("/app/photo-id");
      return;
    }
    handleNext();
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    try {
      const options = { day: "numeric", month: "long", year: "numeric" };
      return new Date(dateStr).toLocaleDateString("en-NZ", options); // 27 April 1948
    } catch {
      return dateStr;
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="intro">
          <h1 className="intro-title-mi" lang="mi-NZ">
            Arotakehia ō taipitopito
          </h1>
          <hr />
          <h1 className="intro-title">Review your details</h1>

          <div style={{ marginTop: 64 }}>
            <FieldError
              InfoStyle={{ maxWidth: 700 }}
              info={
                "Please check this information is correct. This is the information we'll use to verify your identity."
              }
              error={null}
            />

            {appState?.requestPayload?.supportingInformation
              ?.nameChangeSourceCode && <NameChange />}
            {appState?.requestPayload?.supportingInformation
              ?.genderSourceCode && <GenderChange />}
          </div>

          <h2 className="intro-title">
            Your New Zealand birth certificate details
          </h2>

          <div className="step-container-nospace">
            <div className="step-container-box">
              <p className="label">Given name(s)</p>
              <p className="value">
                {birthData?.namesKnownAs?.[0].givenNames || "-"}
              </p>
            </div>

            <div className="step-container-box">
              <p className="label">Your surname or family name</p>
              <p className="value">
                {birthData?.namesKnownAs?.[0].familyName || "-"}
              </p>
            </div>

            <div className="step-container-box">
              <p className="label">Date of birth</p>
              <p className="value">{formatDate(birthData?.dateOfBirth)}</p>
            </div>

            <div className="step-container-box">
              <p className="label">Place of birth (town/city)</p>
              <p className="value">
                {birthData?.placeOfBirth?.trim()
                  ? birthData.placeOfBirth
                  : "Unknown"}
                </p>
            </div>

            <div className="step-container-box">
              <p className="label">Country of birth</p>
              <p className="value">{addressCountryLabel || "-"}</p>
            </div>

            <div className="step-container-box">
              <p className="label">Gender</p>
              <p className="value">{genderLabel || "-"}</p>
            </div>

            <div className="step-container-box">
              <p className="label">Parent 1/Mother's given name(s)</p>
              <p className="value">
                {supportingInformation?.parent1GivenNames || "-"}
              </p>
            </div>

            <div className="step-container-box">
              <p className="label">Parent 1/Mother's surname or family name</p>
              <p className="value">
                {supportingInformation?.parent1FamilyName || "-"}
              </p>
            </div>

            <div className="step-container-box">
              <p className="label">Parent 2/Father's given name(s)</p>
              <p className="value">
                {supportingInformation?.parent2GivenNames || "-"}
              </p>
            </div>

            <div className="step-container-box">
              <p className="label">Parent 2/Father's surname or family name</p>
              <p className="value">
                {supportingInformation?.parent2FamilyName || "-"}
              </p>
            </div>
          </div>
        </div>

        <div className="step-button-container">
          <SubmitButton text={"Confirm"} type="submit" Icon={Check} />
          <BackButton text={"Back"} onClick={handleBack} />
        </div>
      </form>
    </>
  );
};

export default ReviewBirthDetails;
